import React, { useEffect } from 'react';
import BelegDokumentView from './BelegDokumentView';
import { BelegKontext } from '../lib/belegFelder';
import './BelegAnsichtModal.css';

interface Props {
  /** Vollstaendige URL des Beleg-Ansicht-Endpunkts (inkl. API_URL-Prefix, inkl. ?typ=). */
  url: string;
  /** Titel in der Kopfzeile, z.B. "Rechnung R-0010". */
  title: string;
  /** Kontext fuer Inline-Speicherpfade (leer = read-only Beleg, z.B. Ausgangsrechnung). */
  kontext: BelegKontext;
  onClose: () => void;
}

/**
 * Beleg-Dokumentansicht im Modal: zeigt die strukturierte BelegDokumentView
 * (Spec 2026-08-25 §4). Overlay, Kopfzeile und Esc-Verhalten stammen vom
 * fruehreen Inline-PDF-Viewer — daher die `pdfv-`-Klassen im Stylesheet.
 */
const BelegAnsichtModal: React.FC<Props> = ({ url, title, kontext, onClose }) => {
  // Schließen per Esc
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="pdfv-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={title}>
      <div className="pdfv-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pdfv-header">
          <span className="pdfv-title">{title}</span>
          <div className="pdfv-actions">
            <button type="button" className="pdfv-btn pdfv-close" title="Schließen" onClick={onClose}>
              ✕
            </button>
          </div>
        </div>
        <div className="pdfv-body">
          <BelegDokumentView ansichtUrl={url} kontext={kontext} />
        </div>
      </div>
    </div>
  );
};

export default BelegAnsichtModal;
